module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/area_map-26b8ff2dc9df6736974cd13aa053cc11.png";